export default __webpack_public_path__ + "static/media/Wembley-01.a6a75f1e.jpg";